import React from "react";

const LocationCard = ({ image, title, onClick }) => {
  return (
    <div className="flex-shrink-0 cursor-pointer group w-[280px]" onClick={onClick}>
      <div className="overflow-hidden border border-gray-100">
        <img
          src={image}
          alt={title}
          loading="lazy"
          className="w-full h-[170px] object-bottom object-cover group-hover:scale-105 transition-transform duration-300"
        />
      </div>
      <p className="mt-2 text-sm font-medium text-gray-800 group-hover:text-blue-600 transition-colors duration-150">
        {title}
      </p>
    </div>
  );
};

export default LocationCard;
